import React from 'react';
import { shape, string } from 'prop-types';
import classnames from 'classnames';
import { Dot as AndesDot } from '@andes/badge';
import { getDotColor } from '../../utils/dotColorMap';

const namespace = 'ui-pdp-summary__dot';

const SummaryDot = ({ dot = null, className = null }) => {
  if (!dot) {
    return null;
  }
  const dotColor = getDotColor(dot);
  return (
    <AndesDot
      color={dotColor}
      className={classnames(`${namespace}`, {
        [`${className}`]: className,
        [`${namespace}--black`]: dotColor === 'grey',
      })}
    />
  );
};

SummaryDot.propTypes = {
  dot: shape({
    color: string,
  }),
  className: string,
};

export default SummaryDot;
